import { config } from "../../../config";
import { getLogo } from "../../layout";
import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
// import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { sprintf } from "sprintf-js";
import parse from 'html-react-parser';
    
import {
  Badge,
  Nav,
  NavItem,
  NavLink,
  Navbar,
  NavbarBrand,
  Collapse,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";


import { notificationApi, selectAllNotification } from "../../../modules/push-notification/reducers/notificationSlice";
// import { selectConversationByIdOrFirtInList } from "../../../modules/conversation/reducers/conversationSlice";

/*--------------------------------------------------------------------------------*/
/* Import images which are need for the HEADER                                    */
/*--------------------------------------------------------------------------------*/

// import logodarkicon from "../../../assets/images/logo-icon-tcs.png";
// import logolighticon from "../../../assets/images/logo-light-icon.png";
// import logodarktext from "../../../assets/images/logo-text.png";
// import logolighttext from "../../../assets/images/logo-light-text.png";
import moment from "moment";
import { useNavigate } from "react-router-dom";

export default () => {
  const [isOpen, setIsOpen] = useState(false);
  const settings = useSelector((state) => state.settingReducer);
  const notifications = useSelector( (state) => selectAllNotification(state) );
  const status = useSelector( (state) => state.notificationReducer.status );
  // const selectedConversationId = useSelector( (state) => state.conversationReducer.selectedConversationId);
  // const conversation = useSelector( (state) => selectConversationByIdOrFirtInList(state, selectedConversationId) );

  const dispatch = useDispatch();
  // const history = useHistory()
  const navigate = useNavigate()

  

  useEffect(() => {
    if(status === 'idle') {
      dispatch( notificationApi.fetchLast() )
    }
  }, [dispatch, status, notifications]);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  const showMobilemenu = () => {
    document.getElementById("main-wrapper").classList.toggle("show-sidebar");
  };

  const sidebarHandler = () => {
    let element = document.getElementById("main-wrapper");
    switch (settings.activeSidebarType) {
      case "full":
      case "iconbar":
        element.classList.toggle("mini-sidebar");
        if (element.classList.contains("mini-sidebar")) {
          element.setAttribute("data-sidebartype", "mini-sidebar");
        } else {
          element.setAttribute("data-sidebartype", settings.activeSidebarType);
        }
        break;

      case "overlay":
      case "mini-sidebar":
        element.classList.toggle("full");
        if (element.classList.contains("full")) {
          element.setAttribute("data-sidebartype", "full");
        } else {
          element.setAttribute("data-sidebartype", settings.activeSidebarType);
        }
        break;
      default:
    }
  };

  const parseNotificationDate = (datetime) => {
    const time = moment(datetime).format('hh:mm a');
    const day = moment(datetime).format('DD-MM hh:mm a');

    return (moment().isSame(datetime, 'day')) ? time : day;
  }

  const getMessageCounter = () => {
    
    let counter = 0;
    // notifications.forEach(element => {
    //   if(conversation === undefined || element.payload.conversation_sid !== conversation.conversation_sid) {
    //     counter += element.count_with_tag;
    //   } // TODO: generalizzare
    // });
    return counter;
  }

  const markAllNotificationRead = () => {
    const now = moment().toISOString();
    const data = notifications.map( notification => {
      return {...notification, read_at: now};
    });
    dispatch(notificationApi.updateAll(data));
    document.body.click();
  }

  const navigateTo = (notification) => {
    navigate('/conversations', {
      state: {
        notification: notification.payload,
      }
    });
  }

  const getNotificationEllipsedBody = (notification) => {
    const body = notification.count_with_tag > 1 ? sprintf(notification.body, notification.count_with_tag) : notification.body;
    return body.truncate(120)
  }
  
  return (
    <header className="topbar navbarbg" data-navbarbg={settings.activeNavbarBg}>      
      <Navbar
        className={
          "top-navbar " +
          (settings.activeNavbarBg === "skin6" ? "navbar-light" : "navbar-dark")
        }
        expand="md"
      >
        <div
          className="navbar-header"
          id="logobg"
          data-logobg={settings.activeLogoBg}
          style={{left: '0px'}}
        >
          {/*--------------------------------------------------------------------------------*/}
          {/* Mobile View Toggler  [visible only after 768px screen]                         */}
          {/*--------------------------------------------------------------------------------*/}
          <span
            className="nav-toggler d-block d-md-none xxx"
            onClick={() => showMobilemenu()}
          >
            <i className="ti-menu ti-close" />
          </span>
          {/*--------------------------------------------------------------------------------*/}
          {/* Logos Or Icon will be goes here for Light Layout && Dark Layout                */}
          {/*--------------------------------------------------------------------------------*/}
          <NavbarBrand href="/">
            <b className="logo-icon">
              <img src={getLogo()} alt="homepage" className="dark-logo" width={40} height={40}/>
              {/* <img src={logolighticon} alt="homepage" className="light-logo" width={40} height={40} /> */}
            </b>
            <span className="logo-text">
              {/* <img src={logodarktext} alt="homepage" className="dark-logo" /> */}
              {/* <img src={logolighttext} className="light-logo" alt="homepage" /> */}
              {/* Total control <b>STORE</b> */}
              { parse(config.instance.name) }
            </span>
          </NavbarBrand>
          {/*--------------------------------------------------------------------------------*/}
          {/* Mobile View Toggler  [visible only after 768px screen]                         */}
          {/*--------------------------------------------------------------------------------*/}
          <span
            className="topbartoggler d-block d-md-none"
            onClick={toggle.bind(null)}
          >
            <i className="ti-more" />
          </span>
        </div>
        <Collapse
          className="navbarbg"
          isOpen={isOpen}
          navbar
          data-navbarbg={settings.activeNavbarBg}
          style={{position: 'relative', left: "-15px"}}
        >
          <Nav className="float-left" navbar>
            <NavItem>
              <NavLink
                href="#"
                className="d-none d-md-block"
                onClick={() => sidebarHandler()}
              >
                <i className="ti-menu" />
              </NavLink>
            </NavItem>
          </Nav>
          <Nav className="ml-auto float-right" navbar>
            {/*--------------------------------------------------------------------------------*/}
            {/* Start Notifications Dropdown                                                   */}
            {/*--------------------------------------------------------------------------------*/}
            {<UncontrolledDropdown nav inNavbar>
              {/* <DropdownToggle nav caret>
                <i className="mdi mdi-message font-18" />
                { 
                  (notifications.length > 0 && getMessageCounter() > 0) 
                  ? (<Badge color="danger" pill style={{ position: 'relative', left: '2px', top: '-15%', color: '#fff'}}> {getMessageCounter()} </Badge>) 
                  : (<></>)
                }
              </DropdownToggle> */}
              { 
                  (notifications.length > 0) 
                  ? (<DropdownMenu direction="down" className="mailbox" end style={{overflow: 'hidden', maxHeight: (window.innerHeight - 100)+'px', left: '-280px', width: '350px' }}>
                        {notifications.map((notification, index) => 
                          (
                            <DropdownItem key={index} onClick={() => { navigateTo(notification) }}>
                              <div className="message-center notifications">
                                <span className="message-item" style={{border: 0, padding: 0}} key={index} onClick={() => { navigateTo(notification) }}>
                                  <div className="mail-content">
                                    <h5 className="message-title">
                                      {notification.title}
                                    </h5>
                                    <span className="mail-desc">{ getNotificationEllipsedBody(notification) }</span>
                                    <span className="time">{ parseNotificationDate(notification.created_at) }</span>
                                  </div>
                                </span>
                              </div>
                            </DropdownItem>
                          )
                        )}
                      <a className="nav-link text-center mb-1 text-dark" onClick={markAllNotificationRead} style={{cursor: 'pointer'}}>
                        <strong>Clear all notifications</strong>{" "}
                        <i className="fa fa-angle-right" />
                      </a>
                    </DropdownMenu>) 
                  // ? (<DropdownMenu direction="down" className="mailbox" end style={{overflowY: 'scroll', maxHeight: (window.innerHeight - 100)+'px', left: '-285px' }}>
                  //     <div className="message-center notifications">
                  //       {notifications.map((notification, index) => {
                  //         return (
                  //           <span className="message-item" style={{width: '350px'}} key={index} onClick={() => { navigateTo(notification) }}>
                  //             <div className="mail-content">
                  //               <h5 className="message-title">
                  //                 {notification.title}
                  //               </h5>
                  //               <span className="mail-desc">{ getNotificationEllipsedBody(notification) }</span>
                  //               <span className="time">{ parseNotificationDate(notification.created_at) }</span>
                  //             </div>
                  //           </span>
                  //         );
                  //       })}
                  //     </div>
                  //     <a className="nav-link text-center mb-1 text-dark" onClick={markAllNotificationRead} style={{cursor: 'pointer'}}>
                  //       <strong>Clear all notifications</strong>{" "}
                  //       <i className="fa fa-angle-right" />
                  //     </a>
                  //   </DropdownMenu>) 
                  : (<></>)
                }
              
            </UncontrolledDropdown>}
            {/*--------------------------------------------------------------------------------*/}
            {/* End Notifications Dropdown                                                     */}
            {/*--------------------------------------------------------------------------------*/}
                        
            {/*--------------------------------------------------------------------------------*/}
            {/* Start Create New Dropdown                                                      */}
            {/*--------------------------------------------------------------------------------*/}
            {/* <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav>
                <i className={"flag-icon flag-icon-"+config.defaultLanguage.code}></i>
                <i className="pl-1 pr-2 fa fa-caret-down" aria-hidden="true"></i>
              </DropdownToggle>
              <DropdownMenu right>
                {
                  config.languages.map( (language) => {
                    return (<DropdownItem key={language.code}>
                      <i className={"flag-icon flag-icon-"+language.code}></i> {language.label}
                    </DropdownItem>)
                  })
                }
              </DropdownMenu>
            </UncontrolledDropdown> */}
            {/*--------------------------------------------------------------------------------*/}
            {/* End Create New Dropdown                                                        */}
            {/*--------------------------------------------------------------------------------*/}
            {/*--------------------------------------------------------------------------------*/}
            {/* Start Profile Dropdown                                                         */}
            {/*--------------------------------------------------------------------------------*/}
            {/* <UncontrolledDropdown nav inNavbar>
              <DropdownToggle nav caret className="pro-pic">
                <img
                  src={identity.avatar ? identity.avatar : userPlaceholder}
                  alt="user"
                  className="rounded-circle"
                  width="31"
                />
              </DropdownToggle>
              <DropdownMenu right className="user-dd">
                <div className="d-flex no-block align-items-center p-3 bg-info text-white mb-2">
                  <div className="">
                    <img
                      src={identity.avatar ? identity.avatar : userPlaceholder}
                      alt="user"
                      className="rounded-circle"
                      width="60"
                    />
                  </div>
                  <div className="ml-2">
                    <h4 className="mb-0 text-white">{identity.firstname} {identity.lastname}</h4>
                    <p className=" mb-0">{identity.email}</p>
                  </div>
                </div>
                <DropdownItem>
                  <i className="ti-user mr-1 ml-1" /> My Account
                </DropdownItem>
                <DropdownItem>
                  <i className="ti-wallet mr-1 ml-1" /> My Balance
                </DropdownItem>
                <DropdownItem>
                  <i className="ti-email mr-1 ml-1" /> Inbox
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem>
                  <i className="ti-settings mr-1 ml-1" /> Account Settings
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="/login" onClick={(event) => {
                  dispatch(deviceApi.logout());
                  event.preventDefault();
                }}>
                  <i className="fa fa-power-off mr-1 ml-1" /> Logout
                </DropdownItem>
                <DropdownItem divider />
                <Button color="success" className="btn-rounded ml-3 mb-2 mt-2">
                  View Profile
                </Button>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            {/*--------------------------------------------------------------------------------*/}
            {/* End Profile Dropdown                                                           */}
            {/*--------------------------------------------------------------------------------*/}
          </Nav>
        </Collapse>
      </Navbar>
    </header>
  );
};
